/**
 * Sticky Add to Cart Bar
 * Shows a fixed bar at the bottom when user scrolls past the main add to cart button.
 * Syncs variant selection with the main product form.
 */
(function () {
  let intersectionObserver = null;

  function removeStickyButtonLoading() {
    document.querySelectorAll('.sticky-add-to-cart-bar__button.loading').forEach((btn) => {
      btn.classList.remove('loading');
      const spinner = btn.querySelector('.loading__spinner');
      if (spinner) spinner.classList.add('hidden');
    });
  }

  function initStickyAddToCartBar() {
    const stickyBar = document.querySelector('.sticky-add-to-cart-bar');
    if (!stickyBar) return;

    const sectionId = stickyBar.dataset.sectionId;
    if (!sectionId) return;

    const addToCartTarget = document.getElementById(`ProductAddToCart-${sectionId}`);
    if (!addToCartTarget) return;

    // Clean up previous observer
    if (intersectionObserver) {
      intersectionObserver.disconnect();
    }

    // IntersectionObserver: show bar only when add to cart has scrolled OUT of view (above viewport)
    // When add to cart is below the fold, isIntersecting=false but we must not show the bar yet
    intersectionObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.target === addToCartTarget) {
            const rect = entry.boundingClientRect;
            if (entry.isIntersecting) {
              stickyBar.classList.add('hidden');
              stickyBar.setAttribute('aria-hidden', 'true');
            } else {
              // Only show when user has scrolled past (add to cart is above viewport)
              // rect.top < 0 means element has moved above the visible area
              const hasScrolledPast = rect.top < 0;
              if (hasScrolledPast) {
                stickyBar.classList.remove('hidden');
                stickyBar.setAttribute('aria-hidden', 'false');
              } else {
                stickyBar.classList.add('hidden');
                stickyBar.setAttribute('aria-hidden', 'true');
              }
            }
          }
        });
      },
      {
        root: null,
        rootMargin: '0px',
        threshold: 0,
      }
    );

    intersectionObserver.observe(addToCartTarget);

    // Sync sticky variant dropdowns to main variant-selects
    const mainVariantSelects = document.getElementById(`variant-selects-${sectionId}`);
    const stickySelects = stickyBar.querySelectorAll('[data-sticky-option-index]');

    stickySelects.forEach((stickySelect) => {
      stickySelect.removeEventListener('change', handleStickyVariantChange);
      stickySelect.addEventListener('change', handleStickyVariantChange);
    });

    function handleStickyVariantChange(event) {
      if (!mainVariantSelects) return;

      const optionIndex = parseInt(event.target.dataset.stickyOptionIndex, 10);
      const selectedValue = event.target.value;

      const optionContainers = mainVariantSelects.querySelectorAll('.product-form__input');
      const targetContainer = optionContainers[optionIndex];
      if (!targetContainer) return;

      const mainSelect = targetContainer.querySelector('select');
      if (mainSelect) {
        mainSelect.value = selectedValue;
        mainSelect.dispatchEvent(new Event('change', { bubbles: true }));
        return;
      }

      const mainRadio = targetContainer.querySelector(`input[type="radio"][value="${CSS.escape(selectedValue)}"]`);
      if (mainRadio) {
        mainRadio.checked = true;
        mainRadio.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    // Loading state when sticky button submits the form
    const productForm = document.getElementById(stickyBar.dataset.productFormId);
    const stickyButton = stickyBar.querySelector('[data-sticky-add-to-cart]');
    if (productForm && stickyButton) {
      productForm.addEventListener('submit', (evt) => {
        if (evt.submitter === stickyButton) {
          stickyButton.classList.add('loading');
          const spinner = stickyButton.querySelector('.loading__spinner');
          if (spinner) spinner.classList.remove('hidden');
        }
      });
    }
  }

  // Remove loading from sticky button when cart update completes (single global subscription)
  if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, removeStickyButtonLoading);
    subscribe(PUB_SUB_EVENTS.cartError, removeStickyButtonLoading);
  }

  function init() {
    initStickyAddToCartBar();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('product-info:loaded', init);
})();
